module.exports = __webpack_public_path__ + "img/28.8bc9b56c.jpg";